import { App } from "../App";
import { DesktopView } from "../View/AppView/DesktopView";
import { DesktopViewController } from "../Controller/ViewController/DesktopViewController";
import { GuiResizeEvent, DataReceiveEvent } from "@gaming/srvg-classes-core";
/**
 * <strong>VF - Virtual Football</strong>
 *
 * This is the Desktop application class for VF.
 */
export class DesktopApp extends App {
    desktopView:DesktopView;
    desktopViewController:DesktopViewController;
    mainChannel:number;
    protected resizeTimeout:number;
    protected layoutDelay:number;

    constructor(options) {
        super(options || {});
        // Object.assign({}, window, {Srvg: Srvg, Vf: Vf, Widgets: Widgets, VfWidgets: VfWidgets});
        this.resizeTimeout = 0;
        this.layoutDelay = 100;
        this.mainChannel = options.mainChannel || 0;
        this.addSubscriberForEvent(this, GuiResizeEvent);

    }

    handleDataReceiveEvent( event: DataReceiveEvent, provider ) {
        if ( provider === this.templateEngine ) {
            this.view = this.desktopView = new DesktopView({});
            this.viewController = this.desktopViewController = new DesktopViewController( { desktopView: this.desktopView } );
        }
    }
}